// This method is used to obtain the values for keys in our route
export default function params(matches, keys = {}) {
  const result = {};

  // So for example /user/:id, we'll match the value of :id to 'id'
  for (let n = 1; n < matches.length; n++) {
    if (!matches[n]) {
      continue;
    }
    result[keys[n - 1].name] = decodeURIComponent(matches[n]);
  }

  // And return the result
  return result;
}
